import _              from 'lodash'
import moment         from 'moment'
import Immutable      from 'immutable'
import { formatDate } from 'alto-utils/lib/utils'
import { Meal       } from 'alto-react-canteen/lib/models'

export default class Orders
  constructor: (@backend) ->

  orderMeal: (canteenID, date, course, number) ->
    body = { canteen: canteenID, date: formatDate(date), course: course.name, number }

    @backend.requestWithAuth('POST', '/canteen/order_meal', { body })

  unorderMeal: (canteenID, date, course) ->
    body = { canteen: canteenID, date: formatDate(date), course: course.name }

    @backend.requestWithAuth('DELETE', '/canteen/unorder_meal', { body })

  orderCourseGroup: (canteenID, date, group, orders) ->
    body = { canteen: canteenID, date: formatDate(date), group: group.name, orders }

    @backend.requestWithAuth('POST', '/canteen/order_course_group', { body })

  cancelCourseGroup: (canteenID, date, group) ->
    body = { canteen: canteenID, date: formatDate(date), group: group.name }

    @backend.requestWithAuth('DELETE', '/canteen/cancel_course_group', { body })

  # @param orders: Map<canteenID,
  #                    Map<formattedDate,
  #                        Map<groupName,
  #                            [{ course: courseName, number: selectedMealNumber }]>>>>
  saveAll: (orders) ->
    # Map<[canteenID, date, groupName], orders>
    flat = orders.flatMap (canteenOrders, canteenID) ->
      canteenOrders.flatMap (dailyOrders, date) ->
        dailyOrders.mapKeys (groupName) ->
          [canteenID, date, groupName]

    # [{ canteen: canteenID, date: formattedDate, group: groupName,
    #    orders: [{ course: courseName, number: selectedMealNumber }]}]
    data = flat
      .map (orders, [canteenID, date, groupName]) ->
        { canteen: canteenID, date, group: groupName, orders }
      .valueSeq().toArray()

    @backend.requestWithAuth('POST', '/canteen/bulk_order', { body: data })
